import React from "react";
import DocumentUploader from "@/components/DocumentUploader";
import { FileLock2 } from "lucide-react";

export default function PortalDocuments() {
  return (
    <div data-testid="portal-documents">
      <div className="flex items-start gap-4 mb-6">
        <div className="w-12 h-12 rounded-lg bg-[#1A2433] flex items-center justify-center flex-shrink-0">
          <FileLock2 className="w-5 h-5 text-[#DC2626]" />
        </div>
        <div>
          <h2 className="font-heading text-3xl font-bold text-[#1A2433] mb-1">Meine Dokumente</h2>
          <p className="text-slate-600">
            Laden Sie Ausweis-, Pass- und Firmendokumente sicher hoch. Wir benötigen diese für die
            Gründung, Identifikation und für laufende Mandate.
          </p>
        </div>
      </div>
      <DocumentUploader />
    </div>
  );
}
